<template>
  <ion-button @click="modalController.dismiss()" fill="clear"
    ><ion-icon slot="icon-only" :icon="close"></ion-icon
  ></ion-button>
</template>

<script>
import { IonButton, IonIcon, modalController } from "@ionic/vue";
import { close } from "ionicons/icons";

export default {
  components: {
    IonButton,
    IonIcon,
  },
  setup() {
    return { close, modalController };
  },
};
</script>

<style lang="scss" scoped>
ion-button {
  position: absolute;
  right: 0;
  top: 0;
}
</style>
